import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import VideoCard from "../components/VideoCard";
import { useAuth } from "../context/AuthContext";

export default function Following() {
  const { user } = useAuth();
  const [data, setData] = useState(null);

  useEffect(() => { if (user) api.get("/following").then((r) => setData(r.data)); }, [user]);

  if (!user) return (
    <div className="py-20 text-center">
      <h1 className="font-display text-3xl mb-3">Sign in to follow artists</h1>
      <Link to="/login" className="text-cyan-400 hover:underline">Log in</Link>
    </div>
  );
  if (!data) return null;

  return (
    <div>
      <h1 className="font-display text-4xl sm:text-5xl font-extrabold mb-6">Following</h1>
      {data.artists.length === 0 ? (
        <div className="text-zinc-500 py-16 text-center">
          You&apos;re not following any artists yet.{" "}
          <Link to="/videos" className="text-cyan-400 hover:underline">Discover artists →</Link>
        </div>
      ) : (
        <>
          <div className="flex flex-wrap gap-3 mb-8">
            {data.artists.map((a) => (
              <div key={a.slug} className="flex items-center gap-3 px-3 py-2 bg-zinc-900/60 border border-white/10 rounded-full" data-testid={`following-artist-${a.slug}`}>
                <img src={a.image} alt="" className="w-8 h-8 rounded-full object-cover" />
                <span className="text-sm font-semibold">{a.name}</span>
              </div>
            ))}
          </div>
          <h2 className="font-display text-2xl font-bold mb-4">Latest from your artists</h2>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
            {data.videos.map((v) => <VideoCard key={v.id} video={v} size="sm" queue={data.videos} />)}
          </div>
          {!data.videos.length && <div className="text-zinc-500 py-16 text-center">No videos from your followed artists yet.</div>}
        </>
      )}
    </div>
  );
}
